import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pb-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "mt-3" }, "Folders", -1)
const _hoisted_3 = {
  key: 0,
  class: "row mt-3"
}
const _hoisted_4 = { class: "col" }
const _hoisted_5 = {
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_6 = {
  key: 1,
  class: "row mt-3"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "alert alert-primary",
    role: "alert"
  }, "No folders found")
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "row mt-3 py-3 border-bottom border-top bg-light" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "row mt-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, "Name")
], -1)
const _hoisted_15 = { class: "col-10" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 d-flex align-items-center" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "col-10" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-gray-500" }, "This folder is protected")
], -1)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-12 d-flex justify-content-end mt-3" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "row pt-3" }
const _hoisted_25 = { class: "col" }
const _hoisted_26 = {
  key: 0,
  class: "d-flex mt-5 justify-content-center align-items-center"
}
const _hoisted_27 = {
  key: 1,
  class: "w-100"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Date Created"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-right" }, "Protected")
  ])
], -1)
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "col-8" }
const _hoisted_31 = { class: "text-secondary" }
const _hoisted_32 = { style: {"text-align":"center"} }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col d-flex justify-content-center mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_confirm_dialog = _resolveComponent("confirm-dialog")!
  const _component_VPagination = _resolveComponent("VPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.error != '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.error), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.error == '' && !_ctx.loading && _ctx.folders.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.selectedFolder.id !== "" ? "Edit" : "Add New") + " Folder", 1)
          ]),
          (_ctx.selectedFolder.id !== '')
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                style: {"cursor":"pointer"},
                title: "Stop editing",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.unselectFolder()))
              }, [
                _createVNode(_component_font_awesome_icon, {
                  class: "mr-3",
                  icon: ['fas', 'times']
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              required: "",
              disabled: _ctx.selectedFolder.protected,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedFolder.name) = $event))
            }, null, 8, _hoisted_16), [
              [_vModelText, _ctx.selectedFolder.name]
            ])
          ])
        ]),
        (_ctx.selectedFolder.protected)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_20))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            (
                _ctx.selectedFolder.id !== '' &&
                !_ctx.selectedFolder.protected &&
                _ctx.selectedFolder.name !== 'Inbox'
              )
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-danger mr-1",
                  "data-toggle": "tooltip",
                  "data-placement": "bottom",
                  title: "Delete",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.deleteFolder && _ctx.deleteFolder(...args)))
                }, " Delete Folder "))
              : _createCommentVNode("", true),
            (_ctx.selectedFolder.id === '')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-primary",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addFolder && _ctx.addFolder(...args)), ["prevent"])),
                  disabled: _ctx.selectedFolder.name && _ctx.selectedFolder.name.length === 0
                }, " Add Folder ", 8, _hoisted_23))
              : _createCommentVNode("", true),
            (_ctx.selectedFolder.id !== '' && !_ctx.selectedFolder.protected)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "btn btn-primary",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.renameFolder && _ctx.renameFolder(...args)), ["prevent"]))
                }, " Update Folder "))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(_component_confirm_dialog, { ref: "confirmDialog" }, null, 512),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        (_ctx.loading && _ctx.error.length != 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createVNode(_component_font_awesome_icon, {
                class: "text-primary",
                icon: ['fas', 'spinner'],
                size: "lg",
                spin: ""
              })
            ]))
          : _createCommentVNode("", true),
        (!_ctx.loading && _ctx.folders.length > 0)
          ? (_openBlock(), _createElementBlock("table", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.folders, (fld) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: fld.id,
                    class: _normalizeClass(fld.id == _ctx.selectedFolder.id ? 'selected-row' : ''),
                    onClick: _withModifiers(($event: any) => (_ctx.selectedFolder = { ...fld }), ["prevent"])
                  }, [
                    _createElementVNode("td", _hoisted_30, _toDisplayString(fld.name), 1),
                    _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.formatDate(fld.dateCreated)), 1),
                    _createElementVNode("td", _hoisted_32, [
                      (fld.protected)
                        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                            key: 0,
                            class: "text-secondary",
                            icon: ['fas', 'lock']
                          }))
                        : _createCommentVNode("", true),
                      (!fld.protected)
                        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                            key: 1,
                            class: "text-primary",
                            icon: ['fas', 'lock-open']
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ], 10, _hoisted_29))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createVNode(_component_VPagination, {
              pagination: _ctx.foldersPagination,
              "onUpdate:pagination": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.foldersPagination) = $event)),
              onPageChanged: _cache[6] || (_cache[6] = (page) => (_ctx.currentPage = page)),
              class: "float-right"
            }, null, 8, ["pagination"])
          ])
        ])
      ])
    ])
  ]))
}